module.exports = __webpack_public_path__ + "media/base/builder_medium-7f5076b0.svg";